import m2Sidebar from "@components/sidebar/m2_sidebar";
export default {
  components: {
    m2Sidebar
  },
  data: function() {
    return {
      gradeItems: [],
      gradeWidth: ["考试名称", "科目名称", "准考证号"],
      infoState: false
    };
  },
  methods: {
    getData: function() {
      this.$http.get(globalProvider.serviceUrl("eis/g/ets")).then(data => {
        if (data.body.code === resultCode.Success) {
          this.infoState = true;
          this.gradeItems = data.body.data;
          if (this.gradeItems.length > 0) {
            for (let grade of this.gradeItems) {
              grade.tableData = this.setData(grade);
              grade.title = this.setTitle(grade);
            }
          }
        } else if (data.body.code == resultCode.NotSuccess) {
          if (data.body.message == "SWITCH_OFF") {
            this.$router.push({
              name: "default.closeTip",
              params: { type: "grade", time: JSON.stringify(data.body.data) }
            });
          } else this.$alert(getErrorMessage(data.body.message));
        }
      });
    },
    setTitle: function(grade) {
      let data = [],
        index = 0;
      for (let i of grade.score_info) {
        if (i["单元分"]) {
          if (grade.score_info[index]["单元分"]) {
            if (grade.score_info[index]["单元分"].length < i["单元分"].length) {
              index = grade.score_info.indexOf(i);
            }
          } else {
            index = grade.score_info.indexOf(i);
          }
        }
      }
      for (let i in grade.title_info) {
        if (
          grade.title_info[i] == "单元分" &&
          grade.score_info[index]["单元分"] != null
        ) {
          for (let j = 0; j < grade.score_info[index]["单元分"].length; j++) {
            data.push("name" + j);
            data.push("score" + j);
          }
        } else {
          data.push(grade.title_info[i]);
        }
      }
      return data;
    },
    setData: function(grade) {
      let data = [];
      for (let i of grade.score_info) {
        let item = {};
        for (let j in i) {
          if (j != "单元分") {
            item[j] = i[j];
          } else {
            if (i[j] != null) {
              for (let unit of i[j]) {
                let name = "name" + i[j].indexOf(unit);
                let score = "score" + i[j].indexOf(unit);
                item[name] = unit.name;
                item[score] = unit.score;
              }
            }
          }
        }
        data.push(item);
      }
      return data;
    },
    getname(title) {
      if (title.indexOf("name") != -1) {
        return "单元名称";
      } else if (title.indexOf("score") != -1) {
        return "单元分";
      } else {
        return title;
      }
    }
  },
  created: function() {
    this.getData();
    this.$store.commit("setHeaderState", "5");
  }
};